var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 132.9 144",
    style: {
      enableBackground: "new 0 0 132.9 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st5{fill:#1834CB;}\n\t.st6{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st5",
    width: 132.9,
    height: 144
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3,
    y: 3.3,
    className: "st6",
    width: 126.3,
    height: 90.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M98.4,19.7L73.6,78.8H57.4L45.2,31.6c-0.7-2.9-1.4-4-3.6-5.2c-3.7-2-9.8-3.9-15.1-5l0.4-1.7h26 c3.3,0,6.3,2.2,7.1,6l6.4,34.2l15.9-40.2H98.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M33.1,131.4v-27.5h10c2,0,3.7,0.3,5.2,0.9s2.7,1.6,3.5,2.9c0.8,1.3,1.2,2.9,1.2,4.9c0,2-0.4,3.6-1.2,4.9 c-0.8,1.3-2,2.2-3.5,2.8s-3.2,0.9-5.2,0.9H38v10.1H33.1z M42.4,107.7H38v9.9h4.4c1.8,0,3.2-0.4,4.1-1.1c1-0.7,1.4-2,1.4-3.8 c0-1.9-0.5-3.1-1.4-3.9S44.2,107.7,42.4,107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.8,131.4h-4.5l10.2-27.5h5.2l10.2,27.5h-5.2l-2.7-7.5H60.5L57.8,131.4z M61.7,120.2h8.1l-4-11.1h-0.1 L61.7,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.4,131.4v-11.9l-9.7-15.6h5.4l7.2,11.9h0.1l7.1-11.9h4.4l-9.7,15.5v11.9H87.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpay);
export default __webpack_public_path__ + "static/media/vpay.978dd0c9a7513d4606d18422b417ac9b.svg";
export { ForwardRef as ReactComponent };